export default function photoQcValidation(validatedData) {
    return {
        validatedData,

        setAccept(id, sub = null) {
            this.validatedData[id] = {
                approved: true,
                reasons: sub ? [
                    {main: 'accept', sub}
                ] : []
            };
        },

        toggleReason(id, code, sub = null) {
            let entry = this.validatedData[id] || {
                approved: false,
                reasons: []
            };

            entry.approved = false;

            
            let reasons = entry.reasons;
            let idx = reasons.findIndex(r => r.main === code);
            let hasAcceptIdx = reasons.findIndex(r => r.main === 'accept');
            if (hasAcceptIdx > -1) {
                reasons.splice(hasAcceptIdx, 1);
            }

            if (idx === -1) {
                reasons.push({ main: code, sub });
            } else {
                if (sub !== null) {
                    reasons[idx].sub = sub;
                } else {
                    reasons.splice(idx, 1);

                    if (reasons.length === 0) {
                        this.setAccept(id);
                        return;
                    }
                }
            }

            this.validatedData[id] = entry;
        }
    };
}